import Layout from "@/components/layout/Layout";
import HeroCarousel from "./components/HeroCarousel";
import CategoryEntries from "./components/CategoryEntries";
import LatestNews from "./components/LatestNews";
import HotPicks from "./components/HotPicks";
import SiteIntro from "./components/SiteIntro";

export default function Home() {
  return (
    <Layout>
      <HeroCarousel />
      <CategoryEntries />
      <LatestNews />
      <HotPicks />
      <SiteIntro />
    </Layout>
  );
}